const stripCategoryMonth = (entries, categoria, year, month) =>
  (entries || []).filter(d => !(d.categoria === categoria && d.year === year && d.month === month));

export const applyEditsToConsolidatedData = (geralData, editedByCategory) => {
  const categorias = Object.keys(editedByCategory || {});
  if (categorias.length === 0) return geralData;

  let { planoData, realizadoData, estoquePecasData, ...rest } = geralData;

  categorias.forEach((categoria) => {
    const editedMonths = editedByCategory[categoria] || {};

    Object.entries(editedMonths).forEach(([key, edited]) => {
      const [year, month] = key.split('-').map(Number);

      if (edited.editedBase) {
        const originalPlano = (planoData || []).find(
          d => d.categoria === categoria && d.year === year && d.month === month
        ) || {};

        realizadoData = stripCategoryMonth(realizadoData, categoria, year, month);

        // planoData = stripCategoryMonth(planoData, categoria, year, month).concat([{
        //   ...originalPlano,
        //   categoria,
        //   year, month,
        //   grossRevenue: edited.grossRevenue,
        //   unitsSold: edited.unitsSold,
        //   originalPrice: edited.originalPrice,
        //   unitCost: edited.unitCost ?? originalPlano.unitCost,
        //   salePrice: edited.salePrice ?? originalPlano.salePrice,
        //   markdownPercent: edited.markdownPercent ?? originalPlano.markdownPercent,
        //   initialMarkup: edited.initialMarkup ?? originalPlano.initialMarkup,
        //   finalMarkup: edited.finalMarkup ?? originalPlano.finalMarkup,
        //   grossProfit: edited.grossProfit ?? originalPlano.grossProfit,
        // }]);
        planoData = stripCategoryMonth(planoData, categoria, year, month).concat([{
          ...originalPlano,
          categoria,
          year, month,
          grossRevenue: edited.grossRevenue,
          unitsSold: edited.unitsSold,
          originalPrice: edited.originalPrice,
          unitCost: edited.unitCost ?? originalPlano.unitCost,
          salePrice: edited.salePrice ?? originalPlano.salePrice,
          markdownPercent: edited.markdownPercent ?? originalPlano.markdownPercent,
          initialMarkup: edited.initialMarkup ?? originalPlano.initialMarkup,
          finalMarkup: edited.finalMarkup ?? originalPlano.finalMarkup,
          grossProfit: edited.grossProfit ?? originalPlano.grossProfit,
          editedOverride: true,
        }]);        
      }

      const originalEstoque = (estoquePecasData || []).find(
        d => d.categoria === categoria && d.year === year && d.month === month
      ) || {};

      estoquePecasData = stripCategoryMonth(estoquePecasData, categoria, year, month).concat([{
        ...originalEstoque,
        categoria,
        year, month,
        initialInventoryUnits: edited.initialInventoryUnits ?? originalEstoque.initialInventoryUnits,
        endingInventoryUnits: edited.endingInventoryUnits ?? originalEstoque.endingInventoryUnits,
        inboundInventoryUnits: edited.inboundInventoryUnits ?? originalEstoque.inboundInventoryUnits,
        openToBuyUnits: edited.openToBuyUnits ?? originalEstoque.openToBuyUnits,
        grossOpenToBuyUnits: edited.grossOpenToBuyUnits ?? originalEstoque.grossOpenToBuyUnits,
        minimumInventoryUnits: edited.minimumInventoryUnits ?? originalEstoque.minimumInventoryUnits,
        actualInventoryCoverage: edited.actualInventoryCoverage ?? originalEstoque.actualInventoryCoverage,
        plannedInventoryCoverage: edited.plannedInventoryCoverage ?? originalEstoque.plannedInventoryCoverage,
      }]);
    });
  });

  return { planoData, realizadoData, estoquePecasData, ...rest };
};